import src from "IMAGE";
export default { src, width: 5068, height: 849, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AMCu9IPgyc9RtrS6TbSyuE+pp61asrC2UcTDxz6ysLZRXHkUQvJOFloAAAAASUVORK5CYII="};
